import { ReduxService } from 'dashboard-services/services';

import { shareDialogActions } from 'actions/modules/tools';

export const shareDialogInitialState = {
  groupName: undefined,
  owner: undefined
}

export default (state = shareDialogInitialState, action) => {

  switch (action.type) {
    case shareDialogActions.ON_CHANGE: {
      if(state[action.name] !== action.value) {
        return ReduxService.updateObject(state, { [action.name]: action.value })
      }
      return state;
    }
    default:
      return state;
  }
}